import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { ReactiveFormsModule, RequiredValidator } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { AbstractFormComponent } from '../abstract-form-component';
import { CommonModule } from '@angular/common';
import { FormLabelComponent } from '@design-system/typography/form-label/form-label.component';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [RequiredValidator],
  standalone: true,
  imports: [
    CommonModule,
    MatCheckboxModule,
    FormLabelComponent,
    MatFormFieldModule,
    ReactiveFormsModule,
  ],
})
export class CheckboxComponent extends AbstractFormComponent implements OnChanges {
  @Input() override label = '';
  @Input() initialChecked: boolean | undefined;
  @Output('change') checkedChange = new EventEmitter<unknown>();

  override ngOnInit(): void {
    super.ngOnInit();
    this.syncFormControlToInitialChecked();
  }

  changeValue(event: any) {
    this.formControl.setValue(event.checked);
    this.checkedChange.emit(event);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['initialChecked']) {
      this.syncFormControlToInitialChecked();
    }
  }

  private syncFormControlToInitialChecked(): void {
    if (this.initialChecked !== undefined) {
      this.formControl.setValue(this.initialChecked);
    }
  }
}
